import React from 'react';
import { FaFacebookSquare, FaInstagram, FaTwitter, FaMobileAlt } from 'react-icons/fa';
import { HiMail } from 'react-icons/hi';
import './css/header.css';

const Header = () => {
    return (
        <header>
            <div>
                <div className='top_nav-details'>
                    <div><a href='tel:123456789' ><FaMobileAlt /> 123456789</a></div>
                    <div><a href='mailto:harshithadevelopers@gmail.com' ><HiMail style={{ fontSize: '1.3rem' }} /> harshithadevelopers@gmail.com</a></div>
                </div>
                <div className='top_nav-socials'>
                    <div className='socialmedia_icons'>
                        <li><a href='https://www.facebook.com/'><i><FaFacebookSquare /></i> </a></li>
                        <li><a href='https://www.youtube.com/'><FaInstagram /></a></li>
                        <li><a href='https://www.youtube.com/'><FaTwitter /></a></li>
                        <li><a href='https://www.youtube.com/'><FaInstagram /></a></li>
                    </div>
                </div>
            </div>
        </header>
    )
}

export default Header;
